import { actions } from '../../utils/constants';

export const asyncSendEmail = (payload) => ({
    type: actions.NEW_SEND_EMAIL,
    payload,
});